import { useState, useContext } from 'react';
import { XCircle } from 'lucide-react';
import AuthContext from '../../../../../../../context/AuthContext';
import { useToast } from '../../../../../../../context/ToastContext';
import ConfirmationModal from '../../../../../../../components/ConfirmationModal';
import auditPlanService from '../../../../../../../services/audit_services/auditPlanService';

export default function CloseModal({ isOpen, onClose, planId, onSuccess }) {
  const { authTokens } = useContext(AuthContext);
  const { showError, showSuccess } = useToast();
  const [loading, setLoading] = useState(false);

  const handleClose = async () => {
    setLoading(true);
    
    try {
      const result = await auditPlanService.closeAuditPlan(authTokens.access, planId);
      
      if (result.success) {
        showSuccess('Plan d\'audit clôturé avec succès');
        onSuccess();
        onClose();
      } else {
        showError(result.error || 'Erreur lors de la clôture du plan d\'audit');
      }
      setLoading(false);
    } catch (error) {
      console.error('Error closing audit plan:', error);
      showError('Erreur lors de la clôture du plan d\'audit');
      setLoading(false);
    }
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleClose}
      title="Clôturer le plan d'audit"
      message="Êtes-vous sûr de vouloir clôturer ce plan d'audit ? Cette action marque le plan comme clôturé."
      confirmText={loading ? 'Clôture...' : 'Clôturer'}
      confirmButtonClass="bg-red-600 hover:bg-red-700"
      icon={<XCircle className="h-6 w-6 text-red-600" />}
      loading={loading}
    />
  );
}
